import { MuiBackdrop } from './back-drop';
import { MuiButton } from './button';
import { MuiDateCalendar  } from './calander-picker';
import { MuiCheckbox } from './checkbox';
import { MuiCssBaseline } from './css-baseline';
import { MuiDesktopDatePicker } from './desktop-date-picker';
import { MuiDialog } from './dialog';
import { MuiFormLabel } from './form-label';
import { MuiIconButton } from './icon-button';
import { MuiPagination } from './pagination';
import { MuiList } from './list';
import { MuiMenuItem } from './menu-item';
import { MuiModal } from './modal';
import { MuiPaper } from './paper';
import { MuiRadio } from './radio';
import { MuiSlider } from './slider';
import { MuiStepConnector } from './step-connector';
import { MuiStepLabel } from './step-label';
import { MuiTab } from './tab';
import { MuiTablePagination } from './table-pagination';
import { MuiTextField } from './text-field';
import { MuiTreeItem } from './tree-item';
import { MuiTreeView } from './tree-view';

export const overrides = {
    MuiBackdrop,
    MuiButton,
    MuiDateCalendar ,
    MuiCheckbox,
    MuiCssBaseline,
    MuiDesktopDatePicker,
    MuiDialog,
    MuiFormLabel,
    MuiIconButton,
    MuiPagination,
    MuiList,
    MuiMenuItem,
    MuiModal,
    MuiPaper,
    MuiRadio,
    MuiSlider,
    MuiStepConnector,
    MuiStepLabel,
    MuiTab,
    MuiTablePagination,
    MuiTextField,
    MuiTreeItem,
    MuiTreeView
}